import React from 'react';
import NotificationJewelV3 from 'Components/NotificationJewel/NotificationJewelV3';

const AdditionalBadgesJewelV3: React.FC<{
  additionalItems: [React.ReactNode | React.ReactNode[]];
}> = ({ additionalItems }) => (
  <NotificationJewelV3
    variant="primary-outline"
    content={`+${additionalItems.length.toLocaleString()}`}
  />
);

export default React.memo(AdditionalBadgesJewelV3);
